import { render, staticRenderFns } from "./AppEmbedded.vue?vue&type=template&id=a461c134&"
import script from "./AppEmbedded.vue?vue&type=script&lang=js&"
export * from "./AppEmbedded.vue?vue&type=script&lang=js&"
import style0 from "./AppEmbedded.vue?vue&type=style&index=0&id=a461c134&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports